export default __webpack_public_path__ + "static/media/reveal-conversation-pink.0485a0be.svg";